module.exports = __webpack_public_path__ + "assets/img/kv-6067e2f3.jpg";